import * as React from "react";
import { IconProps } from "../types";

const RatingIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <g clip-path="url(#clip0_699_17237)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.76348 4.57714L6.86929 0.738861L4.9751 4.57714L0.738525 5.19275L3.80391 8.18118L3.08006 12.4L6.86929 10.4086L8.39516 11.2105L7.35805 9.00099C7.06605 8.37599 7.33705 7.63199 7.96205 7.33999C8.58805 7.04699 9.33205 7.31699 9.62505 7.94299L10.048 8.84217L9.93467 8.18118L13 5.19275L8.76348 4.57714Z"
            fill={color}
            fill-opacity="0.3"
          />
          <path
            d="M5.579 11.092L3.09 12.4L3.813 8.185L0.75 5.2L4.982 4.585L6.875 0.75L8.768 4.585L13 5.2L11.676 6.49"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.25 15.225C17.25 13.166 17.014 11.586 16.25 11.002C15.375 10.333 13.098 10.164 10.955 10.77L9.62499 7.94298C9.33199 7.31698 8.58799 7.04698 7.96199 7.33998C7.33699 7.63198 7.06599 8.37598 7.35799 9.00098L9.91899 14.457L7.19499 13.956C6.60799 13.848 6.02799 14.18 5.82399 14.741C5.59199 15.378 5.92199 16.081 6.55999 16.31L9.17599 17.251"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_699_17237">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

export default RatingIcon;
